export default global.alert.bind(global.window)
